<template>
	<div class="news">
		<!-- <div class="aboutus_banner" :style="{
              backgroundImage: 'url(' + banner + ')'
            }"></div> -->
		<banner title="关于我们" :img="sty" />
		<div class="aboutus_selection">
			<div class="clearfix">
				<div :class="checked == 1 ? 'selected' : ''" @click="change(1)">
					<span>公司简介</span>
				</div>
				<div :class="checked == 2 ? 'selected' : ''" @click="change(2)">
					<span>董事长致辞</span>
				</div>
				<div :class="checked == 3 ? 'selected' : ''" @click="change(3)">
					<span>荣誉资质</span>
				</div>
				<div :class="checked == 4 ? 'selected' : ''" @click="change(4)">
					<span>成员企业</span>
				</div>
				<div :class="checked == 5 ? 'selected' : ''" @click="change(5)">
					<span>企业架构</span>
				</div>
				<div :class="checked == 6 ? 'selected' : ''" @click="change(6)">
					<span>企业文化</span>
				</div>
			</div>
		</div>
		<div v-if="checked == 1" class="jianjie">
			<div class="clearfix" v-html="jianjie"></div>
			<div class="clearfix"><img :src='jianjiebtimg' /></div>
		</div>
		<div v-if="checked == 2" class="jingli">
			<div class="content" v-html="zhici"></div>
			<div class="content"><img :src='zhiciimg' /></div>
		</div>
		<div v-if="checked == 3" class="zizhi">
			<div class="qiye">
				<div class="content">
					<div class="title">
						<span>企业资质</span>
					</div>
					<div class="clearfix">
						<div>
							<img src="../assets/img/zhongyi/zizhi/01.png" alt="" />
							<p>海关AEO高级认证企业</p>
						</div>
						<div>
							<img src="../assets/img/zhongyi/zizhi/02.png" alt="" />
							<p>全国货运代理100强</p>
						</div>
						<div>
							<img src="../assets/img/zhongyi/zizhi/03.png" alt="" />
							<p>DOC船舶安全符合证书</p>
						</div>
						<div>
							<img src="../assets/img/zhongyi/zizhi/04.png" alt="" />
							<p>高校大学生实习基地</p>
						</div>
					</div>
				</div>
			</div>
			<div class="zhengshu">
				<div class="content">
					<p>证书展示</p>
					<div class="clearfix">
						<!-- <button type="button" @click="show">Click to show</button> -->
						<viewer :images="images" ref="viewer" @inited="inited" class="viewer clearfix">
							<!-- <img :src="item" style="display: none;"> -->
							<div class="biankuang" v-for="(item, index) in zhengshu" :key="'0' + index">
								<img :src="item" style="display: none;" />
								<div class="zhanshi" :style="{ backgroundImage: 'url(' + item + ')' }">
									<div class="zezao" @click="show(index)">
										<i class="el-icon-search"></i>
									</div>
								</div>
							</div>
						</viewer>
						<!-- <div class="biankuang" v-for="(item,index) in zhengshu" :key="'0' + index">
							<div class="zhanshi">
								<el-image :src="item.tu" :preview-src-list="[item.tu]" :fit="cover">
									
								</el-image>
								<div class="zezao">
									<i class="el-icon-search"></i>
								</div>
							</div>
							
						</div> -->
					</div>
				</div>
			</div>
		</div>
		<div v-if="checked == 4" class="chengyuan">
			<div class="clearfix">
				<div class="left" @mouseenter="mouseOvenFn" @mouseleave="mouseOutFn">
					<img @click="qiehuan('0')" class="jiantouleft" src="../assets/img/zhongyi/jiantouleft.png" alt="">
					
					<div class="picboxdad">
						<div class="picbox" :style="{'left': leftStyle +'px'}">
							<div v-for="(item, index) in list" :key="index" :class="selected == index ? 'selected' : ''"
							@click="xuanze(index)">
								<div class="content">
									<div class="tupian" :style="{ backgroundImage: 'url(' + item.showpath + ')' }"></div>
									<!-- <p>{{ item.companyname }}</p> -->
								</div>
							</div>
						</div>
					</div>

					<img @click="qiehuan('1')" class="jiantouright" src="../assets/img/zhongyi/jiantouright.png" alt="">
				</div>
				<div class="right" @mouseenter="mouseOvenFn" @mouseleave="mouseOutFn">
					<!-- <div class="right-left"><img :src='bigshoupic'></div>
					<div class="right-right">
						<div class='title'>{{title}}</div>
						<div class='content ql-snow ql-editor' v-html='detail'></div>
					</div> -->

					
					<div class="membercont">
						<div class='title'>{{title}}</div>
						<div class="txtcont">
							<div class="img"><img :src='bigshoupic'></div>
							<div class='content ql-snow ql-editor' v-html='detail'></div>
						</div>
					</div>



				</div>
			</div>
		</div>
		<div v-if="checked == 5" class="jiagou">
			<div class="jiagoubox">
				<img class="jiagoutop" src="../assets/img/zhongyi/jiagoutop.jpg" alt="" />
				<div class="neirong">
					<img class="toubu" src="../assets/img/zhongyi/jiagou4.png" alt="" />
					<div class="dongshizhang" :title="dongshizhangdetail">{{dongshizhang}}</div>
					<div class="zongjingli" :title="zongjinglidetail">{{zongjingli}}</div>
					<div class="left1">生产设备 Production Equipment</div>
					<div class="left2">副总经理 Vice General Manager</div>
					<div class="left3">分公司 Foreign Branch</div>
					<!-- <div class="left4">船务部</div> -->
					<div class="clearfix jiagoucontent">
						<div class="left" style="float: left;margin-left: 138px;width: 259px;min-height: 10px;">
							<div v-if="leftlist.length != 0">
								<img style="margin:-26px 0 0 8px;display: block;" src="../assets/img/zhongyi/left1.png">
								<div style="padding-top: 13px;">
									<div style="padding-top: 16px;" class="clearfix" v-for="(item,index) in leftlist"
										:key="index">
										<img style="float: left;margin-top: -30px;" src="../assets/img/zhongyi/left2.png">
										<div style="float: left;box-sizing: border-box;width: 230px;height: 36px;border: 1px solid #3491db;font-size: 15px;background-color: #fff;color: #3491db;line-height: 34px;text-align: center;border-radius: 5px;cursor: pointer;">
											<el-tooltip  effect="light" :content="item.showdesc" placement="top">
												<el-button style="color: #3491db; border:0 none; width: 100%; padding: 0; height: 100%; display: block;">{{item.name}}</el-button>
											</el-tooltip>
										</div>
									</div>
								</div>
					
							</div>
						</div>
						<div class="center1" style="float: left;margin-left: 48px;width: 259px;min-height: 10px;">
							<div v-if="centerlist1.length != 0">
								<img style="margin:-26px 0 0 8px;display: block;" src="../assets/img/zhongyi/left1.png">
								<div style="padding-top: 13px;">
									<div style="padding-top: 16px;" class="clearfix" v-for="(item,index) in centerlist1"
										:key="index">
										<img style="float: left;margin-top: -30px;" src="../assets/img/zhongyi/left2.png">
										<div style="float: left;box-sizing: border-box;width: 230px;height: 36px;border: 1px solid #3491db;font-size: 15px;background-color: #fff;color: #3491db;line-height: 34px;text-align: center;border-radius: 5px;cursor: pointer;">
											<el-tooltip  effect="light" :content="item.showdesc" placement="top">
												<el-button style="color: #3491db; border:0 none; width: 100%; padding: 0; height: 100%; display: block;">{{item.name}}</el-button>
											</el-tooltip>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- <div class="center2" style="float: left;margin-left: 44px;width: 259px;min-height: 10px;">
							<div v-if="centerlist2.length != 0">
								<img style="margin:-26px 0 0 8px;display: block;" src="../assets/img/zhongyi/left1.png">
								<div style="padding-top: 13px;">
									<div style="padding-top: 16px;" class="clearfix" v-for="(item,index) in centerlist2"
										:key="index">
										<img style="float: left;margin-top: -30px;" src="../assets/img/zhongyi/left2.png">
										<div style="float: left;box-sizing: border-box;width: 230px;height: 46px;border: 1px solid #3491db;font-size: 15px;background-color: #fff;color: #3491db;line-height: 44px;text-align: center;border-radius: 5px;cursor: pointer;"
											:title="item.showdesc">{{item.name}}</div>
									</div>
								</div>
							</div>
						</div> -->
						<div class="right" style="float: left;margin-left: 44px;width: 259px;min-height: 10px;">
							<div v-if="rightlist.length != 0">
								<img style="margin:-26px 0 0 8px;display: block;" src="../assets/img/zhongyi/left1.png">
								<div style="padding-top: 13px;">
									<div style="padding-top: 16px;" class="clearfix" v-for="(item,index) in rightlist"
										:key="index">
										<img style="float: left;margin-top: -30px;" src="../assets/img/zhongyi/left2.png">
										<div style="float: left;box-sizing: border-box;width: 230px;height: 36px;border: 1px solid #3491db;font-size: 15px;background-color: #fff;color: #3491db;line-height: 34px;text-align: center;border-radius: 5px;cursor: pointer;">
											<el-tooltip  effect="light" :content="item.showdesc" placement="top">
												<el-button style="color: #3491db; border:0 none; width: 100%; padding: 0; height: 100%; display: block;">{{item.name}}</el-button>
											</el-tooltip>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				
			</div>

		</div>
		<div v-if="checked == 6" class="enterpriseculture">
			<div class="culturebox">
				<div class="title">
					<div class="big">企业文化</div>
					<div class="sml">Corporate culture</div>
				</div>
				<div class="textcont">
					<ul>
						<li>
							<div class="chinese">企业精神：踏实进取，追求卓越</div>
							<div class="english">Enterprise Spirit: Solid Progress, pursuit of excellence</div>
						</li>
						<li>
							<div class="chinese">经营理念：一切为了客户，为了客户的一切，为了一切的客户</div>
							<div class="english">Operation philosophy: all for the customer, for customer's all, for all the customers</div>
						</li>
						<li>
							<div class="chinese">核心价值观：客户就是价值，服务创造财富</div>
							<div class="english">Core values: the customer is the value. services to create wealth</div>
						</li>
						<li>
							<div class="chinese">团队作风：务实、和谐、创新</div>
							<div class="english">Team style: pragmatic, harmony, innovation</div>
						</li>
						<li>
							<div class="chinese">共同愿景：全力打造服务一流的现代物流企业</div>
							<div class="english">Corporate visioin: strive to build up a first-class service modem logistics enterprise.</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Banner from "../components/Banner";
	export default {
		name: "aboutus",
		data() {
			return {
				dongshizhang: '',
				dongshizhangdetail: '',
				zongjingli: '',
				zongjinglidetail: '',
				leftlist: [],
				centerlist1: [],
				centerlist2: [],
				rightlist: [],
				sty: {},
				checked: 1,
				selected: 0,
				list: [],
				title: "",
				tupian: "",
				zhengshu: [],
				jianjie: "",
				jianjiebtimg: '',
				zhici: "",
				zhiciimg: '',
				banner: "",
				detail: "",
				bigshoupic: '',
				images: [
					"http://njsg.f3322.org:28080/img/01.6044d5fe.png",
					"http://njsg.f3322.org:28080/img/02.8602bfb1.png",
					"http://njsg.f3322.org:28080/img/03.d7ec322f.png",
					"http://njsg.f3322.org:28080/img/04.fbc40b24.png",
					"http://njsg.f3322.org:28080/img/05.2b00a5c2.png",
					"http://njsg.f3322.org:28080/img/06.189e76db.png",
					"http://njsg.f3322.org:28080/img/07.eb6b5ae1.png",
					"http://njsg.f3322.org:28080/img/08.480180c8.png",
					"http://njsg.f3322.org:28080/img/09.0a2aa9a7.png",
				],
				picTimer: null,
				leftStyle: 0
			};
		},
		components: {
			Banner,
		},
		destroyed(){
			clearInterval(this.picTimer)
		},
		methods: {
			qiehuan(a){
				var that = this;
				var length = that.list.length;
				if(a == 0){
					if(that.selected == 0){
						that.selected = length - 1;
					}else{
						that.selected--;
					}
				}else{
					if(that.selected == length - 1){
						that.selected = 0;
					}else{
						that.selected++;
					}
				}
				let num = Math.floor(that.selected / 8)
				that.leftStyle = -1094*num;
				that.title = that.list[that.selected].companyname;
				that.detail = that.list[that.selected].companydesc;
				that.bigshoupic = that.list[that.selected].bigshowpath
			},
			//公司简介轮播
			setPicTimer(){
				this.picTimer = setInterval(()=>{
					this.qiehuan('1')
				},3000)
			},
			//鼠标悬停
			mouseOvenFn(){
				clearInterval(this.picTimer)
			},
			//鼠标移出
			mouseOutFn(){
				this.setPicTimer();
			},
			inited(viewer) {
				this.$viewer = viewer;
			},
			show(a) {
				this.$viewer.view(a);
				//this.$viewer.show()
			},
			change(a) {
				var that = this;
				that.checked = a;
			},
			xuanze(a) {
				var that = this;
				that.selected = a;
				that.title = that.list[a].companyname;
				that.detail = that.list[a].companydesc;
				that.bigshoupic = that.list[a].bigshowpath
			},
			getjiagou() {
				var that = this;
				that
					.$axios({
						method: "get",
						url: "webpc/pccompanytree/CompanyTreelist",
						// data: this.$qs.stringify(data)
						params: {

						},
					})
					.then((res) => {
						// console.log(JSON.stringify(res.data));
						// console.log(res.data.data);
						if (res.data.result == 200) {
							console.log(res.data);
							var data = res.data.detail;
							var dongshizhang = data[0];
							that.dongshizhang = dongshizhang.showname;
							that.dongshizhangdetail = '';
							if (dongshizhang.childlist.length != 0) {
								that.dongshizhangdetail = dongshizhang.childlist[0].showdesc;
							}
							var zongjingli = data[1];
							that.zongjingli = zongjingli.showname;
							that.zongjinglidetail = '';
							if (zongjingli.childlist.length != 0) {
								that.zongjinglidetail = zongjingli.childlist[0].showdesc;
							}
							that.leftlist = data[2].childlist;
							that.centerlist1 = data[3].childlist;
							that.centerlist2 = data[4].childlist;
							that.rightlist = data[5].childlist;
						}
					});
			},
			//banner图
			getlunbo() {
				var that = this;
				that
					.$axios({
						method: "get",
						url: "system/pcmanage/list",
						// data: this.$qs.stringify(data)
						params: {
							location: 1,
						},
					})
					.then((res) => {
						// console.log(JSON.stringify(res.data));
						// console.log(res.data.data);
						if (res.data.result == 200) {
							console.log(res.data);
							var data = res.data.detail;
							that.sty = {
								backgroundImage: "url(" + data[0].showpath + ")",
							};
							console.log(that.sty);
						}
					});
			},
			// getlunbo() {
			// 	var that = this;
			// 	that.$axios({
			// 		method: "get",
			// 		url: "system/pcmanage/list",
			// 		// data: this.$qs.stringify(data)
			// 		params: {
			// 			location:1
			// 		}
			// 	}).then(res => {
			// 		// console.log(JSON.stringify(res.data));
			// 		// console.log(res.data.data);
			// 		if(res.data.result == 200){
			// 			var data = res.data.detail;
			// 			that.banner = data[0].showpath;
			// 		}

			// 	})
			// },
			//公司简介
			getjianjie() {
				var that = this;
				that.$http
					.get(
						"webpc/pccompanyabstract/list", {
							params: {
								page: 1,
								pagesize: 10,
							},
						}, {
							emulateJSON: true,
						}
					)
					.then((res) => {
						// console.log(result.data);
						// this.list = result.body.rows
						if (res.data.result == 200) {
							console.log(res.data.detail.list)
							this.jianjiebtimg = res.data.detail.list[0].showpath
							this.jianjie = res.data.detail.list[0].content;
							// console.log(this.jianjie);
						}
					});
				// that.$http.get('webpc/pccompanymaillist/companylist', {
				// 	params: {
				// 		companyarea:'123'
				// 	}
				// }, {
				// 	emulateJSON: true
				// }).then(res => {
				// 	// console.log(result.data);
				// 	// this.list = result.body.rows
				// 	if(res.data.result == 200){
				// 		// this.jianjie = res.data.detail.list[0].content;
				// 		// console.log(this.jianjie);
				// 	}
				// })
			},
			//总经理致辞
			getzhici() {
				var that = this;
				that.$http
					.get(
						"webpc/pcmanagerspeech/list", {
							params: {},
						}, {
							emulateJSON: true,
						}
					)
					.then((res) => {
						// console.log(result.data);
						// this.list = result.body.rows
						if (res.data.result == 200) {
							this.zhiciimg = res.data.detail.showpic
							this.zhici = res.data.detail.content;
							console.log(res.data.detail)
							// console.log(this.zhici);
						}
					});
			},
			//荣誉资质
			getzizhi() {
				var that = this;
				that.$http
					.get(
						"webpc/pccompanyqualification/list", {
							params: {},
						}, {
							emulateJSON: true,
						}
					)
					.then((res) => {
						// console.log(result.data);
						// this.list = result.body.rows
						if (res.data.result == 200) {
							var data = res.data.detail;
							that.zhengshu = [];
							for (var i = 0; i < data.length; i++) {
								that.zhengshu.push(data[i].showpath);
							}
							// that.zhengshu = [
							// 	{
							// 		tu:'http://njsg.f3322.org:28080/img/01.6044d5fe.png'
							// 	},
							// 	{
							// 		tu:'http://njsg.f3322.org:28080/img/02.8602bfb1.png'
							// 	},
							// 	{
							// 		tu:'http://njsg.f3322.org:28080/img/03.d7ec322f.png'
							// 	},
							// 	{
							// 		tu:'http://njsg.f3322.org:28080/img/04.fbc40b24.png'
							// 	},
							// 	{
							// 		tu:'http://njsg.f3322.org:28080/img/05.2b00a5c2.png'
							// 	},
							// 	{
							// 		tu:'http://njsg.f3322.org:28080/img/06.189e76db.png'
							// 	},
							// 	{
							// 		tu:'http://njsg.f3322.org:28080/img/07.eb6b5ae1.png'
							// 	},
							// 	{
							// 		tu:'http://njsg.f3322.org:28080/img/08.480180c8.png'
							// 	},
							// 	{
							// 		tu:'http://njsg.f3322.org:28080/img/09.0a2aa9a7.png'
							// 	},
							// ]
						}
					});
			},
			//公司列表
			getlist() {
				var that = this;
				that
					.$axios({
						method: "post",
						url: "webpc/pccompanymaillist/list",
						// data: this.$qs.stringify(data)
						params: {
							page: 1,
							pagesize: 50000,
						},
					})
					.then((res) => {
						// console.log(JSON.stringify(res.data));

						if (res.data.result == 200) {
							var list = res.data.detail.list;
							that.list = list;
							console.log(that.list[0]);
							that.title = list[0].companyname;
							that.detail = list[0].companydesc;
							that.bigshoupic = list[0].bigshowpath
						}
					});
			},
		},
		mounted() {
			this.checked =
				this.$route.query.checked == undefined ? 1 : this.$route.query.checked;
			var selected =
				this.$route.query.selected == undefined ? 0 : this.$route.query.selected;
			this.selected = selected;

			this.getjianjie();
			this.getzhici();
			this.getzizhi();
			this.getlunbo();
			this.getlist();
			this.getjiagou();
			this.setPicTimer();
		},
		watch: {},
	};
</script>

<style lang="scss" scoped>
	.aboutus_banner {
		width: 100%;
		height: 423px;
		// background-image: url(../assets/img/zhongyi/aboutus_banner.png);
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
	}

	.aboutus_selection {
		width: 100%;

		.clearfix {
			width: 1200px;
			margin: auto;
			padding: 24px 0;

			div {
				float: left;
				box-sizing: border-box;
				width: 16.6%;
				text-align: center;
				height: 24px;
				line-height: 24px;
				cursor: pointer;
				border-right: 1px solid #d2d2d2;

				span {
					display: inline-block;
					height: 18px;
					line-height: 18px;
					padding-left: 30px;
					color: #363636;
					font-size: 16px;
					background-repeat: no-repeat;
					background-position: left top;
					background-size: contain;
				}
			}

			div:last-child {
				border-right: none;
			}

			div.selected span {
				color: #0385ca;
			}

			div:nth-of-type(1) span {
				background-image: url(../assets/img/zhongyi/aboutus-icon/01.png);
			}

			div:nth-of-type(1).selected span {
				background-image: url(../assets/img/zhongyi/aboutus-icon/01-selected.png);
			}

			div:nth-of-type(2) span {
				background-image: url(../assets/img/zhongyi/aboutus-icon/02.png);
			}

			div:nth-of-type(2).selected span {
				background-image: url(../assets/img/zhongyi/aboutus-icon/02-selected.png);
			}

			div:nth-of-type(3) span {
				background-image: url(../assets/img/zhongyi/aboutus-icon/03.png);
			}

			div:nth-of-type(3).selected span {
				background-image: url(../assets/img/zhongyi/aboutus-icon/03-selected.png);
			}

			div:nth-of-type(4) span {
				background-image: url(../assets/img/zhongyi/aboutus-icon/04.png);
			}

			div:nth-of-type(4).selected span {
				background-image: url(../assets/img/zhongyi/aboutus-icon/04-selected.png);
			}

			div:nth-of-type(5) span {
				background-image: url(../assets/img/zhongyi/aboutus-icon/05.png);
			}

			div:nth-of-type(5).selected span {
				background-image: url(../assets/img/zhongyi/aboutus-icon/05-selected.png);
			}

			div:nth-of-type(6) span {
				background-image: url(../assets/img/zhongyi/aboutus-icon/06.png);
			}

			div:nth-of-type(6).selected span {
				background-image: url(../assets/img/zhongyi/aboutus-icon/06-selected.png);
			}
		}
	}
	.enterpriseculture{
		width: 1200px;
		padding: 20px;
		box-sizing: border-box;
		margin: 0 auto 50px;
		color: #fff;
		.culturebox{
			.title{
				padding: 30px 40px;
				background-color: #0070af;
				.big{
					font-weight: 400;
    			font-size: 28px;
				}
				.sml{
					font-size: 24px;
					margin-top: 6px;
					font-weight: 200;
				}
			}

			.textcont{
				padding: 60px 40px 100px;
				background-color: #ecf2f6;
				color: #666;
				background-image: url(../assets/img/zhongyi/pinbo.png);
				background-repeat: no-repeat;
				background-position: center;
				background-size: cover;
				
				ul{
					li{
						margin: 20px 0 50px;
						padding-left: 50px;
						position: relative;
						::before{
							width: 10px;
							height: 10px;
							content: "";
							position: absolute;
							left: 20px;
							top: 6px;
							border-radius: 50%;
							background: #0070af;
						}
						.chinese{
							font-size: 22px;
						}
						.english{
							font-size: 18px;
							margin-top: 10px;
							font-family: Georgia, 'Times New Roman', Times, serif;
						}
					}
				}
			}
			
		}

	}
	.jianjie {
		background-color: #f2f1ef;
		width: 100%;
		padding: 55px 0 75px;

		.clearfix {
			width: 1200px;
			margin: auto;
		}

		& ::v-deep p {
			font-size: 16px;
			color: #343434;
			line-height: 1.6em;
			margin-bottom: 14px;
			text-align: justify;
			// clear: both;

			strong {
				font-weight: 700;
			}

			img {
				display: block;
				max-width: 100%;
				margin: auto;
			}
		}
	}

	.qiye {
		height: 588px;
		background-image: url(../assets/img/zhongyi/zizhi_banner.png);
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;

		.content {
			width: 1200px;
			margin: auto;
			box-sizing: border-box;
			height: 588px;
			padding-top: 97px;

			.title {
				text-align: center;
				margin-bottom: 82px;

				span {
					display: inline-block;
					height: 88px;
					line-height: 88px;
					padding-left: 89px;
					font-size: 30px;
					color: #fff;
					background-image: url(../assets/img/zhongyi/zizhi/jiangbei.png);
					background-size: contain;
					background-position: left top;
					background-repeat: no-repeat;
				}
			}

			.clearfix {
				div {
					float: left;
					width: 25%;
					text-align: center;

					img {
						display: block;
						width: 129px;
						height: auto;
						margin: 0 auto 32px;
					}

					p {
						color: #fff;
						font-size: 20px;
					}
				}
			}
		}
	}

	.zhengshu {
		background-color: #f2f1ef;

		.content {
			width: 1200px;
			padding-bottom: 40px;
			margin: auto;

			p {
				height: 90px;
				line-height: 90px;
				font-size: 30px;
				color: #272727;
				text-align: center;
			}

			.clearfix {
				.biankuang {
					float: left;
					width: 384px;
					height: 285px;
					margin-bottom: 34px;
					margin-right: 24px;
					box-sizing: border-box;
					background-image: url(../assets/img/zhongyi/biankuang.png);
					background-repeat: no-repeat;
					background-size: contain;
					background-position: center;
					padding-left: 7px;
					padding-top: 7px;
				}

				.zhanshi {
					position: relative;
					width: 370px;
					height: 271px;
					background-size: cover;
					background-repeat: no-repeat;
					background-position: center;

					.zezao {
						position: relative;
						width: 100%;
						height: 100%;
						background-color: rgba(0, 0, 0, 0.7);
						cursor: pointer;
						transition: all 0.3s;
						opacity: 0;

						i {
							position: absolute;
							left: 50%;
							top: 50%;
							transform: translate(-50%, -50%);
							color: #fff;
							font-size: 20px;
						}
					}

					.zezao:hover {
						opacity: 1;
					}
				}

				// .el-image:hover{
				//   transform: scale(1.02);
				//   transform-origin: center center;
				//   box-shadow: 2px 2px 2px rgba(0,0,0,0.3);
				// }
				.biankuang:nth-of-type(3n) {
					margin-right: 0px;
				}
			}
		}
	}

	.jingli {
		padding: 47px 0 84px;
		background-color: #f2f1ef;

		.content {
			width: 1200px;
			margin: auto;

			.clearfix {
				margin: 0 auto 40px;
			}

			& ::v-deep p {
				font-size: 16px;
				color: #343434;
				line-height: 1.6em;
				margin-bottom: 14px;
				text-align: justify;
				text-indent: 32px;
				// clear: both;

				strong {
					font-weight: 700;
				}

				img {
					display: block;
					max-width: 100%;
					margin: auto;
				}
			}
		}
	}

	.chengyuan {
		background-image: url('../assets/img/menberBg.png');
		background-size: 100% auto;
		background-repeat: no-repeat;
		background-position: top;
		padding: 30px 0 0;
		background-color: #162a5d;

		.clearfix {
			width: 1200px;
			margin: auto;
			display: flex;
			flex-direction: column;
			align-items: center;
			.picboxdad{
				width: 1200px;
				overflow: hidden;
			}
			.picbox{
				display: flex;
				width: 100%;
				position: relative;
				left: 0;
				transition: 0.3s left;
				>div {
					box-sizing: border-box;
					padding: 6px 9px;
					cursor: pointer;

					.content {
						box-sizing: border-box;

						.tupian {
							width: 119px;
							height: 100px;
							background-size: cover;
							background-position: center;
							background-repeat: no-repeat;
						}

						// p {
						//   box-sizing: border-box;
						//   width: 157px;
						//   padding: 0 10px;
						//   display: table-cell;
						//   vertical-align: middle;
						//   font-size: 16px;
						//   color: #363636;
						// }
					}
				}

				>div:hover,
				>div.selected {
					background-color: #0083c9;
				}

				>div:hover p,
				>div.selected p {
					color: #fff !important;
				}
			}

			.left {
				width: calc(90% + 46px);
				padding: 10px 0;
				display: flex;
				justify-content:space-between;
				.jiantouleft{
					display: block;
					width: 16px;
					height: 32px;
					margin-top: 40px;
					cursor: pointer;
				}
				.jiantouright{
					display: block;
					width: 16px;
					height: 32px;
					margin-top: 40px;
					cursor: pointer;
				}
				
			}

			.right {
				width: 90%;
				box-sizing: border-box;
				padding: 28px 0px 154px;
				display: flex;
				justify-content: space-between;

				.right-left {
					width: calc(50% - 20px);
					line-height: 1.6em;
					// height: 400px;
					display: flex;
					justify-content: center;
					align-items: flex-start;

					img {
						width: 100%;
						border: 1px solid #eee;
						height: auto;
						transition: 0.5s all;
					}
				}

				.membercont{
					width: 100%;
					background-color: rgba(255, 255, 255, .9);
					overflow: auto;
					padding: 30px;
					// transition: 0.5s all;
					.img{
						float: left;
						margin: 20px; 
						width: 40%;
						text-align: center;
						img{
							width: 100%;
						}
					}
					
					.title {
						padding: 10px 20px;
						box-sizing: border-box;
						border-bottom: 2px solid #febe8b;
						color: #f56e00
					}

					.content {
						margin: 20px;
						font-size: 16px;
						height: auto;
						text-align: justify;
						line-height: 1.6em;
					}
				}

				.right-right {
					width: 50%;
					// height: 400px;
					background-color: rgba(255, 255, 255, .9);
					overflow: auto;
					padding-bottom: 40px;
					transition: 0.5s all;

					.title {
						width: 90%;
						height: 50px;
						line-height: 50px;
						margin: 0 5%;
						padding: 10px 0;
						box-sizing: border-box;
						border-bottom: 2px solid #febe8b;
						color: #f56e00
					}

					.content {
						width: 90%;
						margin: 0 5%;
						overflow: hidden;
						// overflow: auto;
						font-size: 16px;
						height: auto;
					}
				}
			}
		}
	}

	.jiagou {
		background-color: #f2f1ef;
		background-image: url(../assets/img/zhongyi/jiagou-bg3.jpg);
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center;

		min-width: 1200px;
		box-sizing: border-box;
		padding-top: 38px;
		padding-bottom: 82px;

		.jiagoubox {
			margin: auto;
			width: 1173px;
			position: relative;
			.jiagoutop{
				display: block;
				width: 1088px;
				margin: 0 auto 50px;
			}
			.neirong{
				position: relative;
				width: 1173px;
				.toubu {
					position: relative;
					display: block;
					width: 1173px;
				}
				
				.dongshizhang {
					position: absolute;
					left: 430px;
					top: 60px;
					width: 309px;
					height: 53px;
					border-radius: 5px;
					cursor: pointer;
					line-height: 53px;
					font-size: 19px;
					color: #fff;
					text-align: center;
				}
				
				.zongjingli {
					position: absolute;
					left: 448px;
					top: 162px;
					width: 278px;
					height: 53px;
					border-radius: 5px;
					cursor: pointer;
					line-height: 53px;
					font-size: 17px;
					color: #fff;
					text-align: center;
				}
				.left1 {
					position: absolute;
					left: 775px;
					top: 265px;
					width: 230px;
					height: 53px;
					border-radius: 5px;
					cursor: pointer;
					line-height: 53px;
					font-size: 14px;
					color: #fff;
					text-align: center;
				}
				.left2 {
					position: absolute;
					left: 475px;
					top: 265px;
					width: 230px;
					height: 53px;
					border-radius: 5px;
					cursor: pointer;
					line-height: 53px;
					font-size: 14px;
					color: #fff;
					text-align: center;
				}
				.left3 {
					position: absolute;
					left: 170px;
					top: 265px;
					width: 230px;
					height: 53px;
					border-radius: 5px;
					cursor: pointer;
					line-height: 53px;
					font-size: 14px;
					color: #fff;
					text-align: center;
				}
				.left4 {
					position: absolute;
					left: 651px;
					top: 440px;
					width: 230px;
					height: 53px;
					border-radius: 5px;
					cursor: pointer;
					line-height: 53px;
					font-size: 17px;
					color: #fff;
					text-align: center;
				}
			}
		}
	}
</style>
